var viewer_default = {
  "gallery_container": "aaeOt",
  "imageTitleContainer": "GtMVK",
  "clickableItem": "AoZvx",
  "prerender": "gxstu",
  "expandButton": "T229E",
  "itemContainer": "fTdA4",
  "expandIcon": "_5-VIv",
  "itemOverlay": "_0ZpXQ",
  "imageTitle": "_40V3U",
  "pointer": "yWJL-",
  "fadeIn": "ZY5IH",
  "changing_background": "Pcy3v"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
